module.exports = __webpack_public_path__ + "img/Абай облысы.aaf449a0.png";